module.exports = __webpack_public_path__ + "media/images/zj11-w2-2215e3c7e0ce0ea67ebb029629c23d55.png";